/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosError } from "axios";

export type ParsedError = {
  message: string;
  details?: string[];
};

/**
 * Extracts a human-readable message (and optional details) from an AxiosError or unknown error.
 */
export function parseAxiosError(error: unknown): ParsedError {
  const err = error as AxiosError<any>;
  const data = err?.response?.data;

  // 1) { message: "..." }
  if (typeof data?.message === "string") {
    return { message: data.message };
  }

  // 2) { error: "..." }
  if (typeof data?.error === "string") {
    return { message: data.error };
  }

  // 3) { error: { ... } }
  if (data?.error && typeof data.error === "object") {
    const em =
      data.error.message ||
      data.error.description ||
      data.error.error ||
      data.error.error_description ||
      err.message ||
      "Unexpected error.";
    return { message: String(em) };
  }

  // 4) Array-based details
  if (Array.isArray(data?.details)) {
    return {
      message: err.message || "Validation error.",
      details: data.details.map((d: any) => String(d?.message ?? d)).slice(0, 5),
    };
  }

  // 5) Object-based details
  if (data?.details && typeof data.details === "object") {
    const list: string[] = [];
    for (const [k, v] of Object.entries(data.details)) {
      if (Array.isArray(v)) v.forEach(x => list.push(`${k}: ${x}`));
      else if (typeof v === "string") list.push(`${k}: ${v}`);
      else list.push(`${k}: ${JSON.stringify(v)}`);
    }
    return { message: err.message || "Validation error.", details: list.slice(0, 5) };
  }

  // fallback
  return { message: err?.message || "Unexpected error. Please try again." };
}
